const root = document.getElementById('react-available-table');

export const rootSubProjectId = root.getAttribute('data-sub-project-id');
export const rootHousingTypeId = root.getAttribute('data-housing-type-id');
export const rootShowConstructionNumberState = root.getAttribute('data-show-constructionnumber-state');
